import { getInsFromPatient, remoteFormats } from "./index";

export const extractDeleteDocumentParams = (params) => {
  const {
          submitEngine: {
            value: submitEngine
          } = {},
          document    : {
            uniqueId: {
              value: uniqueId
            },
            uuid    : {
              value: uuid
            } = {},
            practice: {
              value: practice
            } = {}
          }
        } = params;
  
  const { ins } = getInsFromPatient(params, remoteFormats.XML);
  
  return {
    ins,
    uniqueId,
    uuid,
    practice,
    submitEngine
  };
};

export const extractJSONDeleteDocumentParams = (params) => {
  const {
          submitEngine,
          document: {
            uniqueId,
            uuid,
            practice
          }
        } = params;
  
  const { ins } = getInsFromPatient(params, remoteFormats.JSON);
  
  return {
    ins,
    uniqueId,
    uuid,
    practice,
    submitEngine
  };
};
